export enum AppRoutes {
  landing = "/",
  home = "/home",
  signin = "/signin",
  signup = "/signup",
  resetPasswordRequest = "/reset-password/request",
  resetPassword = "/reset-password",
  support = "/support",
  settings = "/settings",
  newProject = "/new-project",
  project = "/project/:proj_id",
  credit = "/credit",
  admin = "/admin",
}

export enum ProjectRoutes {
  landing = "/",
  deployment = "/deployment",
  apiKeys = "/apiKeys",
  info = "/info",
}

export enum SettingsRoutes {
  paymentMethods = "/",
}
